export default __webpack_public_path__ + "static/media/call-me-hand.0a41bfc5.png";